import React from "react";
import cx from 'classnames';
import withStyles from "isomorphic-style-loader/withStyles";
import { FormattedMessage, useIntl } from "react-intl";
import { flowRight as compose } from 'lodash';
//Components
import PurchaseServiceUserDetails from "./PurchaseServiceUserDetails";
import PurchaseServiceHistory from "./PurchaseServiceHistory";
import Link from "../../Link/Link";
import Loader from "../../Loader/Loader";
//Helpers
import { withQuery } from "../../../hoc/withGraphql";
import { getUserServiceHistory } from "../../../lib/graphql";
import { GoBackArrow } from "../../Common/Assets/SvgIconComponent/CommonSvgIcon";
//Styles
import bt from '../../../components/commonStyle.css';
import messages from '../../../locale/jsonMessages';

const PurchaseServiceUser = (props) => {
    const { userId } = props;
    const { data: { getUserServiceHistory = {}, refetch, loading } } = props;
    const intl = useIntl();

    return (
        <>
            <div className={cx(bt.displayFlex, bt.justifyContentSpaceBetween, bt.gap8, bt.space4, bt.flexWrap, bt.alignCenter, bt.spaceBottom4)}>
                <h1 className={cx(bt.commonTotalText, bt.fontWeightBold)}>{intl?.formatMessage(messages.servicePlansHistory)}</h1>
                <Link to="/siteadmin/user-purchased-plans" className='goBackLink'>
                    <GoBackArrow />
                    <FormattedMessage  {...messages.goBack} />
                </Link>
            </div>
            {loading && <Loader type={"text"} />}
            {!loading &&
                <div>
                    <PurchaseServiceUserDetails data={getUserServiceHistory?.result} />
                    <PurchaseServiceHistory data={getUserServiceHistory?.results}
                        count={getUserServiceHistory?.count}
                        refetch={refetch} />
                </div>}
        </>
    )
}

export default compose(
    withStyles(bt),
    withQuery(getUserServiceHistory, {
        options: (props) => ({
            variables: {
                currentPage: 1,
                userType: '',
                userId: props?.userId
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    })
)(PurchaseServiceUser); 
